import Typography from "typography"

const typography = new Typography({
  headerFontFamily: ["noto-sans-jp"],
  bodyFontFamily: ["noto-sans-jp"],
  overrideStyles: ({ rhythm }) => ({
    h2: {
      backgroundColor: "rgb(174, 46, 53)",
      color: "#FFFFFF",
      marginTop: rhythm(1.5),
      padding: `${rhythm(0.5)} ${rhythm(3 / 4)}`,
      fontWeight: 400,
    },
  }),
})

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
